<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <section class="sectionContainer place-content-start lg:min-h-full">
    <header2
      v-if="title"
      :text="title"
      :isUmbraco="isUmbraco"
      theme="light"
      classes="mb-20 col-start-2 col-span-12"
    />

    <div
      class="col-start-2 col-span-full lg:col-start-3 lg:col-span-10 overflow-auto whitespace-nowrap pr-6 md:pr-10 relative group"
    >
      <div
        :class="styles"
        v-html="table"
        @touchstart="() => hideIcon === true"
        @touchend="() => hideIcon === false"
      ></div>
      <div
        :class="[
          hideIcon ? 'opacity-0' : 'opacity-100',
          'flex md:hidden absolute top-[10%] right-[5%] group-hover:opacity-0 opacity-100 transition-opacity duration-300 ease-in-out',
        ]"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="60"
          height="60"
          viewBox="0 0 60 60"
          fill="none"
        >
          <g clip-path="url(#clip0_6538_10693)">
            <path
              d="M30.0006 -0.0078125C25.9531 -0.0078125 22.0211 0.787569 18.32 2.35268C14.7472 3.86647 11.54 6.02811 8.78182 8.77987C6.02365 11.5381 3.862 14.7452 2.35463 18.318C0.789522 22.0191 -0.00585938 25.9447 -0.00585938 29.9986C-0.00585938 34.0525 0.789522 37.9781 2.35463 41.6792C3.86842 45.252 6.03006 48.4592 8.78182 51.2173C11.54 53.9755 14.7472 56.1372 18.32 57.6445C22.0211 59.2096 25.9467 60.005 30.0006 60.005C34.0544 60.005 37.98 59.2096 41.6811 57.6445C45.2539 56.1307 48.4611 53.9691 51.2193 51.2173C53.9775 48.4592 56.1391 45.252 57.6465 41.6792C59.2116 37.9781 60.007 34.0525 60.007 29.9986C60.007 25.9447 59.2116 22.0191 57.6465 18.318C56.1327 14.7452 53.971 11.5381 51.2193 8.77987C48.4611 6.02169 45.2539 3.86005 41.6811 2.35268C37.98 0.787569 34.0544 -0.0078125 30.0006 -0.0078125Z"
              fill="#F04E23"
            />
            <path
              d="M43.5123 21.6214C42.9592 21.0682 42.219 20.7592 41.4381 20.7592C40.8687 20.7592 40.34 20.93 39.8927 21.2147C39.7462 20.873 39.5348 20.5558 39.2663 20.2792C38.7051 19.7261 37.973 19.417 37.1922 19.417C36.574 19.417 36.0046 19.6123 35.5247 19.9376C35.3864 19.6773 35.2237 19.4333 35.0122 19.2218C34.451 18.6687 33.7189 18.3596 32.9381 18.3596C32.4663 18.3596 32.0189 18.4816 31.6285 18.685V15.1711C31.6285 14.3902 31.3194 13.6582 30.7663 13.0888C30.205 12.5357 29.473 12.2266 28.6921 12.2266C27.0734 12.2266 25.7557 13.5443 25.7557 15.1629V31.0894L25.4222 30.5607C24.5519 29.1941 22.738 28.7874 21.3633 29.6496C19.9968 30.52 19.5901 32.3339 20.4523 33.7085L24.8203 40.6143C25.4222 41.566 25.8533 42.4445 26.1299 43.2904C27.0978 46.2431 29.8309 48 33.418 48H35.2319C40.275 48 44.3745 43.9005 44.3745 38.8574V23.6955C44.3745 22.9147 44.0654 22.1745 43.5123 21.6132V21.6214ZM42.7477 38.8655C42.7477 43.0057 39.3802 46.3813 35.2319 46.3813H33.418C30.5629 46.3813 28.4155 45.0392 27.6753 42.7861C27.3581 41.8181 26.8701 40.8258 26.195 39.7521L21.827 32.8544C21.4366 32.2444 21.6236 31.431 22.2337 31.0406C22.8437 30.6583 23.6571 30.8372 24.0476 31.4473L27.3825 36.71V15.1711C27.3825 14.4472 27.9682 13.8615 28.6921 13.8615C29.0419 13.8615 29.3672 13.9998 29.6194 14.2438C29.8715 14.496 30.0098 14.8294 30.0098 15.1711V26.7133H31.6366V21.3041C31.6366 20.5802 32.2223 19.9946 32.9462 19.9946C33.296 19.9946 33.6213 20.1328 33.8735 20.3769C34.1256 20.629 34.2639 20.9544 34.2639 21.3041V30.0238H35.8907V22.3616C35.8907 21.6376 36.4764 21.052 37.2003 21.052C37.5501 21.052 37.8754 21.1903 38.1194 21.4343C38.3716 21.6864 38.5099 22.0199 38.5099 22.3616V31.0812H40.1367V23.7037C40.1367 22.9797 40.7223 22.3941 41.4463 22.3941C41.796 22.3941 42.1214 22.5324 42.3735 22.7764C42.6257 23.0285 42.764 23.3539 42.764 23.7037V38.8655H42.7477Z"
              fill="white"
            />
            <path
              d="M18.1113 26.1406L13.039 21.0682L18.1113 15.9959"
              stroke="white"
              stroke-width="1.64852"
            />
            <path
              d="M13.0396 21.0625L23.8184 21.0625"
              stroke="white"
              stroke-width="1.64852"
            />
          </g>
          <defs>
            <clipPath id="clip0_6538_10693">
              <rect width="60" height="60" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  </section>
</template>
<script lang="ts" setup>
import { computed, ref, toRefs } from "vue";
import Header2 from "@components/Typography/Header2.ce.vue";
import { ITableProps } from "@/types/components/ITableProps";

const props = withDefaults(defineProps<ITableProps>(), {
  isUmbraco: false,
});

const { title, table, isUmbraco } = toRefs(props);

const hideIcon = ref(false);

const styles = computed(() => {
  return `
    whitespace-normal
    [&_table]:text-aubergine [&_table]:text-sm [&_table]:lg:text-sm
    [&_tbody]:text-wrap
    [&_thead]:bg-[#B6949A]
    [&_th]:border [&_th]:border-aubergine [&_th]:text-left [&_th]:py-5 [&_th]:px-2 [&_th]:bg-[#B6949A]
    [&_td]:td [&_td]:py-5 [&_td]:px-2 [&_td]:min-w-[120px] [&_td]:border [&_td]:border-aubergine [&_td]:test`;
});
</script>
